const sleep = (milliseconds = 1000) => new Promise(resolve => setTimeout(resolve, milliseconds));

export default sleep;